var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-base-shelf-item"},[_c('div',{staticClass:"edit-shelfname-label"},[_vm._v(_vm._s(_vm.datatype)+"名称")]),_c('el-input',{staticClass:"edit-shelfname-input",attrs:{"maxlength":20,"placeholder":"请输入20字以内的文本信息"},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }